module.exports = __webpack_public_path__ + "static/media/background.c11f97a3.jpg";